import React, { useEffect, useState } from "react";
import {
  Table,
  Empty,
  Row,
  Col,
  Tooltip,
  message,
  notification,
  Modal,
} from "antd";
import {
  BarsOutlined,
  MenuUnfoldOutlined,
  FilePdfOutlined,
  FileOutlined,
  DownloadOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useHistory, Link } from "react-router-dom";
import moment from "moment";
import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "../../util/TableHelper";
import { useMediaQuery } from "react-responsive";
import { odata, queryHelper } from "../../routes/Filters/Helper/index";
import FirmTrackingFilter from "../../routes/Filters/FirmTrackingFilter";
import config from "../../util/ApiforContext";
import Iframe from "react-iframe";
import Replace2x from "../../util/Extensions/ReplaceExtension";

const FirmTrackingListByFirm = (props) => {
  //console.log("detaya tıklanılan sayfa ", props);
  const history = useHistory();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [firmId, setFirmId] = useState(props.firmId);
  const [currency, setCurrency] = useState(props.currency);
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [balance, setBalance] = useState("0,00 ₺");

  useEffect(() => {
    getTableData();
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;

    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }

    RequestHandler.post(
      `/FirmTracking?&$count=true&$orderby=transactionDateValue desc${query}&$skip=${skip}&$top=${take}`,
      {
        FirmId: props.firmId,
        CurrencyCode: currency === "" ? null : currency,
      },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status == 200) {
        setTableData({
          data: res.data.value,
          total: res.data["@odata.count"],
          loading: false,
        });

        const processTypeNames = res.data.value.map(
          (item) => item.processTypeName
        );

        if (res.data["@odata.count"] > 0) {
          setBalance(res.data.value.at(0).balanceString);
        }
      } else {
        setTableData({
          data: [],
          total: 0,
          loading: false,
        });
      }
    });
  };

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const [accountIdForModalReceipt, setAccountIdForModalReceipt] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [isModalVisibleReceipt, setIsModalVisible] = useState(false);
  const [isOut, setIsOut] = useState("");
  const [invoiceData, setInvoiceData] = useState("");
  const [eInvoiceProgramId, setEInvoiceProgramId] = useState("");
  const [invoiceNoId, setInvoiceNoId] = useState("");
  const [einvoiceOrEarchiveid, setEinvoiceOrEarchiveid] = useState("");
  const [clickedButton, setClickedButton] = useState(false);

  const getEInvoiceOrEArchiveData = (id) => {
    const rowMontylplanId = id;
    RequestHandler.get(
      `/FirmTracking/GetEArchiveOrEInvoice/${rowMontylplanId}`
    ).then((res) => {
      const variableIsOut = res.isOut;
      const variableInvoiceData = res.invoiceData;
      const variableEInvoiceProgramId = res.eInvoiceProgramId;
      const variableInvoiceNoId = res.invoiceNoId;
      const variabledId = res.id;

      setEinvoiceOrEarchiveid(variabledId);
      setIsOut(variableIsOut);
      setInvoiceData(variableInvoiceData);
      setEInvoiceProgramId(variableEInvoiceProgramId);
      setInvoiceNoId(variableInvoiceNoId);
    });
  };

  const showModalReceipt = (value) => {
    setAccountIdForModalReceipt(value);

    RequestHandler.get(
      `/FirmTracking/DownloadPdfReceiptColumnsWithDoc?id=${value}&isDownload=false`,
      undefined,
      { rawResponse: true }
    ).then((response) => {
      if (response.status == 200) {
        setPdfUrl(response.data);
        setIsModalVisible(true);
      }
    });
  };

  const downloadDekont = () => {
    const hide = message.loading("Pdf indiriliyor...", 0);
    window.open(
      `${
        config.apiUrl
      }/FirmTracking/DownloadPdfReceiptColumnsWithDoc?id=${accountIdForModalReceipt}&isDownload=true&t=${RequestHandler.getToken()}`
    );
    setIsModalVisible(true);
    alertSuccess("success");
    hide();
  };

  const alertSuccess = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Pdf indirme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const handleOkReceipt = () => {
    setPdfUrl("");
    setIsModalVisible(false);
  };

  const handleCancelReceipt = () => {
    setPdfUrl("");
    setIsModalVisible(false);
  };

  const downloadPdf = (id) => {
    const hide = message.loading("Pdf Açılıyor...", 0);
    setTimeout(hide, 2000);
    RequestHandler.get(`/FirmTracking/GetInvoicePdf/${id}`).then((response) => {
      if (response === "") {
        pdfError("error");
      } else {
        window.open(
          `${
            config.apiUrl
          }/FirmTracking/DownloadEInvoice?fileName=${response}&t=${Replace2x(
            localStorage.getItem("token")
          )}`
        );
      }
    });
  };

  const downloadComingPdf = (id) => {
    const hide = message.loading("Pdf Açılıyor...", 0);
    setTimeout(hide, 2000);
    window.open(`${config.eInvoiceUrl}EInvoiceReceivedPdf/${id}.pdf`);
  };

  const pdfError = (type) => {
    notification[type]({
      message: "HATA",
      description: "Pdf oluşturulamadı.",
      duration: 2,
    });
  };
  const columns = [
    {
      title: "İşlem Tarihi",
      dataIndex: "transactionDateValue",
      key: "transactionDateValue",
      align: "left",
      render: (data) => moment(data).format("L"),
    },
    {
      title: "İşlem Tipi",
      dataIndex: "processTypeName",
      key: "processTypeName",
      align: "left",
      render: (text) => {
        if (text === "Satış Faturası") {
          return "Alış Faturası";
        } else if (text === "Alış Faturası") {
          return "Satış Faturası";
        }
        return text;
      },
    },
    {
      title: "Ödeme Tutarı",
      dataIndex: "collectTotalString",
      key: "collectTotalString",
      align: "center",
      align: "left",
    },
    {
      title: "Gelen Tutar",
      dataIndex: "paymentTotalString",
      key: "paymentTotalString",
      align: "left",
    },
    {
      title: "Bakiye",
      dataIndex: "balanceString",
      key: "balanceString",
      align: "left",
    },
    {
      title: "Detay",
      key: "operation",
      render: (record) => {
        //console.log("recorda tıkalndı", record.id);
        //const MonthlyPlanId = record.id;
        return (
          <Link
            style={{ fontSize: "150%", color: "blue", marginLeft: 10 }}
            to={`/firm-tracking/${firmId}/${record.transactionId}/${record.planId}/${currency}`}
            onClick={() => {
              setClickedButton(true);
              props.onDetailClick(
                record.eArchiveId,
                record.eInvoiceId,
                record.processTypeName,
                record.id,
                true
              );
            }}
          >
            <MenuUnfoldOutlined />
          </Link>
        );
      },
    },
    {
      title: "PDF/Dekont",
      key: "pdfDekont",
      render: (record, data, row) => {
        let icon;
        let onClickFunction;
        const processTypeName = record.processTypeName;

        if (processTypeName === "Tahsilat" || processTypeName === "Ödeme") {
          icon = <FileOutlined />;
          onClickFunction = () => {
            showModalReceipt(record.transactionId);
          };
        } else if (
          (processTypeName === "Alış Faturası" ||
            processTypeName === "Satış Faturası") &&
          record.eInvoiceId === null &&
          record.eArchiveId === null
        ) {
          icon = (
            <Tooltip title="Bu bir, gelir - gider planıdır. Pdf ya da dekont alınamaz.">
              <InfoCircleOutlined />
            </Tooltip>
          );
        } else if (
          processTypeName === "Alış Faturası" ||
          processTypeName === "Satış Faturası"
        ) {
          icon = <FilePdfOutlined />;

          onClickFunction = () => {
            getEInvoiceOrEArchiveData(record.id);
          };

          if (isOut) {
            if (
              (invoiceData != null && eInvoiceProgramId == 2) ||
              (invoiceNoId != "00000000-0000-0000-0000-000000000000" &&
                eInvoiceProgramId == 1)
            ) {
              icon = <FilePdfOutlined />;
              onClickFunction = () => {
                downloadPdf(einvoiceOrEarchiveid);
              };
            } else if (
              invoiceNoId != "00000000-0000-0000-0000-000000000000" &&
              eInvoiceProgramId == 3
            ) {
              icon = <FilePdfOutlined />;
              onClickFunction = () => {
                downloadComingPdf(invoiceNoId);
              };
            }
          } else {
            if (
              (invoiceData != null && eInvoiceProgramId == 2) ||
              (invoiceNoId != "00000000-0000-0000-0000-000000000000" &&
                eInvoiceProgramId == 3)
            ) {
              icon = <FilePdfOutlined />;
              onClickFunction = () => {
                downloadComingPdf(invoiceNoId);
              };
            } else if (
              invoiceNoId != "00000000-0000-0000-0000-000000000000" &&
              eInvoiceProgramId == 1
            ) {
              icon = <FilePdfOutlined />;
              onClickFunction = () => {
                downloadPdf(row.id);
              };
            }
          }
        }

        return (
          <a
            style={{ fontSize: "150%", color: "blue", marginLeft: 20 }}
            onClick={onClickFunction}
          >
            {" "}
            {icon}
          </a>
        );
      },
    },
  ];

  const dataStateChange = (e) => {
    setTableData(e);
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }

    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  return (
    <div>
      <Row id="titleArea">
        <Col xs={24} md={12} lg={12}>
          <h1 style={{ marginBottom: 0 }}>
            <BarsOutlined /> Tüm İşlemler
          </h1>
        </Col>
        <Col xs={24} md={12} lg={12} style={{ textAlign: "end", fontSize: 19 }}>
          <p>Bakiye : {balance}</p>
        </Col>
      </Row>
      <FirmTrackingFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <>
          <Col span={24}>
            <Table
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{
                overflowX: "auto",
                maxHeight: "100%",
                width: "100%",
              }}
              columns={columns}
              onDataStateChange={dataStateChange}
              dataSource={tableData.data}
              loading={tableData.loading}
              sortable={true}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
              }}
              rowKey="id"
            ></Table>
          </Col>
        </>
      </Row>

      <Modal
        title="Dekont"
        width={1000}
        style={{ height: 1000 }}
        visible={isModalVisibleReceipt}
        onOk={handleOkReceipt}
        onCancel={handleOkReceipt}
        footer={null}
      >
        <Row style={{ marginBottom: 10 }}>
          <Col span={20}></Col>
          <Col offset={2} span={4}>
            <a
              style={{ fontSize: 25, marginLeft: 90 }}
              key="download"
              href={pdfUrl}
              target="_blank"
              onClick={downloadDekont}
            >
              <DownloadOutlined />
            </a>
          </Col>
        </Row>

        <Iframe
          styles={{ marginBottom: 25 }}
          key={0}
          src={`${pdfUrl}`}
          width="100%"
          height="1000px"
          // id="myId"
          // className="myClassname"
          display="initial"
          position="relative"
        ></Iframe>
      </Modal>
    </div>
  );
};

export default FirmTrackingListByFirm;
